import * as ambassadorWixHubV1Job from './hub-v1-job-movement-jobs.http.js';
import * as ambassadorWixHubV1JobTypes from './hub-v1-job-movement-jobs.types.js';
import * as ambassadorWixHubV1JobUniversalTypes from './hub-v1-job-movement-jobs.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function submitJob(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixHubV1JobUniversalTypes.SubmitJobRequest,
  ambassadorWixHubV1JobTypes.SubmitJobRequest,
  ambassadorWixHubV1JobUniversalTypes.SubmitJobResponse,
  ambassadorWixHubV1JobTypes.SubmitJobResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixHubV1Job.submitJob(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/jobs',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createFileUploadUrl(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixHubV1JobUniversalTypes.CreateFileUploadUrlRequest,
  ambassadorWixHubV1JobTypes.CreateFileUploadUrlRequest,
  ambassadorWixHubV1JobUniversalTypes.CreateFileUploadUrlResponse,
  ambassadorWixHubV1JobTypes.CreateFileUploadUrlResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixHubV1Job.createFileUploadUrl(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/temporary-files/upload-url',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getJob(): __PublicMethodMetaInfo<
  'GET',
  { jobId: string },
  ambassadorWixHubV1JobUniversalTypes.GetJobRequest,
  ambassadorWixHubV1JobTypes.GetJobRequest,
  ambassadorWixHubV1JobUniversalTypes.GetJobResponse,
  ambassadorWixHubV1JobTypes.GetJobResponse
> {
  const payload = { jobId: ':jobId' } as any;

  const getRequestOptions = ambassadorWixHubV1Job.getJob(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/jobs/{jobId}',
    pathParams: { jobId: 'jobId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listJobs(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixHubV1JobUniversalTypes.ListJobsRequest,
  ambassadorWixHubV1JobTypes.ListJobsRequest,
  ambassadorWixHubV1JobUniversalTypes.ListJobsResponse,
  ambassadorWixHubV1JobTypes.ListJobsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixHubV1Job.listJobs(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/jobs',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryJobs(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixHubV1JobUniversalTypes.QueryJobsRequest,
  ambassadorWixHubV1JobTypes.QueryJobsRequest,
  ambassadorWixHubV1JobUniversalTypes.QueryJobsResponse,
  ambassadorWixHubV1JobTypes.QueryJobsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixHubV1Job.queryJobs(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/jobs/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function terminateJob(): __PublicMethodMetaInfo<
  'POST',
  { jobId: string },
  ambassadorWixHubV1JobUniversalTypes.TerminateJobRequest,
  ambassadorWixHubV1JobTypes.TerminateJobRequest,
  ambassadorWixHubV1JobUniversalTypes.TerminateJobResponse,
  ambassadorWixHubV1JobTypes.TerminateJobResponse
> {
  const payload = { jobId: ':jobId' } as any;

  const getRequestOptions = ambassadorWixHubV1Job.terminateJob(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/jobs/{jobId}/terminate',
    pathParams: { jobId: 'jobId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listMovementLogs(): __PublicMethodMetaInfo<
  'GET',
  { jobId: string },
  ambassadorWixHubV1JobUniversalTypes.ListMovementLogsRequest,
  ambassadorWixHubV1JobTypes.ListMovementLogsRequest,
  ambassadorWixHubV1JobUniversalTypes.ListMovementLogsResponse,
  ambassadorWixHubV1JobTypes.ListMovementLogsResponse
> {
  const payload = { jobId: ':jobId' } as any;

  const getRequestOptions = ambassadorWixHubV1Job.listMovementLogs(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/jobs/{jobId}/logs',
    pathParams: { jobId: 'jobId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DataMovementJob as DataMovementJobOriginal,
  DataMovementJobStatusOptionsOneOf as DataMovementJobStatusOptionsOneOfOriginal,
  JobStatus as JobStatusOriginal,
  JobStatusWithLiterals as JobStatusWithLiteralsOriginal,
  Source as SourceOriginal,
  SourceSourceOneOf as SourceSourceOneOfOriginal,
  WixDataEnvironment as WixDataEnvironmentOriginal,
  WixDataEnvironmentWithLiterals as WixDataEnvironmentWithLiteralsOriginal,
  FileFormat as FileFormatOriginal,
  FileFormatWithLiterals as FileFormatWithLiteralsOriginal,
  MediaType as MediaTypeOriginal,
  MediaTypeWithLiterals as MediaTypeWithLiteralsOriginal,
  WixDataSource as WixDataSourceOriginal,
  LocalizationSource as LocalizationSourceOriginal,
  FileSource as FileSourceOriginal,
  TestSource as TestSourceOriginal,
  DataMovementJobLogs as DataMovementJobLogsOriginal,
  ExternalFileSource as ExternalFileSourceOriginal,
  GoogleSheetsSource as GoogleSheetsSourceOriginal,
  WixMediaSource as WixMediaSourceOriginal,
  WixDataCollectionDefinitionSource as WixDataCollectionDefinitionSourceOriginal,
  Destination as DestinationOriginal,
  DestinationDestinationOneOf as DestinationDestinationOneOfOriginal,
  WixDataDestination as WixDataDestinationOriginal,
  WixDataDestinationWritePolicy as WixDataDestinationWritePolicyOriginal,
  WixDataDestinationWritePolicyWithLiterals as WixDataDestinationWritePolicyWithLiteralsOriginal,
  LocalizationDestination as LocalizationDestinationOriginal,
  FileDestination as FileDestinationOriginal,
  Schema as SchemaOriginal,
  Field as FieldOriginal,
  FieldType as FieldTypeOriginal,
  FieldTypeWithLiterals as FieldTypeWithLiteralsOriginal,
  StoresCatalogProductsDestination as StoresCatalogProductsDestinationOriginal,
  WixMediaDestination as WixMediaDestinationOriginal,
  WixMediaDestinationWritePolicy as WixMediaDestinationWritePolicyOriginal,
  WixMediaDestinationWritePolicyWithLiterals as WixMediaDestinationWritePolicyWithLiteralsOriginal,
  WixDataCollectionDefinitionDestination as WixDataCollectionDefinitionDestinationOriginal,
  WritePolicy as WritePolicyOriginal,
  WritePolicyWithLiterals as WritePolicyWithLiteralsOriginal,
  StoresCatalogInventoryDestination as StoresCatalogInventoryDestinationOriginal,
  TestDestination as TestDestinationOriginal,
  Transformation as TransformationOriginal,
  TransformationTransformationOneOf as TransformationTransformationOneOfOriginal,
  TestTransformation as TestTransformationOriginal,
  Progress as ProgressOriginal,
  ItemsSuccessfulInfo as ItemsSuccessfulInfoOriginal,
  Units as UnitsOriginal,
  UnitsWithLiterals as UnitsWithLiteralsOriginal,
  ApplicationError as ApplicationErrorOriginal,
  PartiallySuccessfulStatusOptions as PartiallySuccessfulStatusOptionsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  SubmitJobRequest as SubmitJobRequestOriginal,
  SubmitJobRequestSiteOverrideOneOf as SubmitJobRequestSiteOverrideOneOfOriginal,
  SubmitJobResponse as SubmitJobResponseOriginal,
  CreateFileUploadUrlRequest as CreateFileUploadUrlRequestOriginal,
  CreateFileUploadUrlResponse as CreateFileUploadUrlResponseOriginal,
  GetJobRequest as GetJobRequestOriginal,
  GetJobResponse as GetJobResponseOriginal,
  ListJobsRequest as ListJobsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  ListJobsResponse as ListJobsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  QueryJobsRequest as QueryJobsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  QueryJobsResponse as QueryJobsResponseOriginal,
  TerminateJobRequest as TerminateJobRequestOriginal,
  TerminateJobResponse as TerminateJobResponseOriginal,
  ListMovementLogsRequest as ListMovementLogsRequestOriginal,
  ListMovementLogsResponse as ListMovementLogsResponseOriginal,
  MovementLog as MovementLogOriginal,
  JobCallback as JobCallbackOriginal,
  JobCallbackOptionsOneOf as JobCallbackOptionsOneOfOriginal,
  InProgressOptions as InProgressOptionsOriginal,
  FailedOptions as FailedOptionsOriginal,
  PartiallySuccessfulOptions as PartiallySuccessfulOptionsOriginal,
  Empty as EmptyOriginal,
  TerminateJobByIdRequest as TerminateJobByIdRequestOriginal,
  TerminateJobByIdResponse as TerminateJobByIdResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './hub-v1-job-movement-jobs.types.js';
